/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { darken, rgba } from 'polished';

export default $ => css`
  html body {
    font-family: ${$.fontFamily};
    font-optical-sizing: auto;
    font-weight: 300;
    font-style: normal;
    font-size: 15px;
  }

  html,
  body,
  #app-root,
  .app-layout {
    width: 100%;
    height: 100vh;
  }

  .app-layout-internal {
    margin-top: calc(${$.navbarHeight});
    height: calc(100% - ${$.navbarHeight});
    min-height: 0;
  }

  body {
    background-color: ${$.gray100} !important;
    letter-spacing: 0.015em;
  }

  a.nav-link {
    cursor: pointer;
  }

  .dont-show-component {
    display: none;
  }

  legend {
    font-weight: bold;
    font-size: 1.75rem;
  }

  .field-description {
    // font-weight: bold;
    // font-size: 1.4rem;
    // font-style: italic;
  }

  .control-label {
    margin-bottom: 4px;
    font-weight: bold;
    margin-bottom: 1rem;

    & > .required {
      color: ${$.dangerMain};
    }

    &:has(.field-label-tooltip) {
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }

  .control-label:not(td):not(.flex) {
    display: block;
  }

  input[type='radio'] {
    margin-right: 0.75rem;
  }

  #root__title {
    margin-bottom: 1.25rem;
    font-weight: bold;
  }

  .form-title {
    text-align: center;
    margin-bottom: 2rem;
  }

  .step-circle {
    background: ${$.primaryMain};
    margin: 0px auto 0.5rem auto;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .step-title {
    color: ${$.primaryMain};
    opacity: 0.5;

    &.active {
      opacity: 1;
      font-weight: 700;
    }
  }

  .rjsf-field-radio-group,
  .field-radio-group {
    display: flex;
    flex-wrap: wrap;

    .radio {
      margin-right: 1rem;
    }

    .radio-inline {
      margin-right: 1rem;
    }
  }

  input[type='checkbox'] {
    margin-right: 8px;
    accent-color: ${$.primaryMain};
    cursor: pointer;
  }

  .card.clickable:hover {
    background: ${$.gray100};
    cursor: pointer;
  }

  .sort-button {
    white-space: nowrap;
  }

  .form-submit-buttons > :not(:first-of-type) {
    margin-left: 45px;
  }

  div.is-a-p {
    margin-bottom: 1rem;
  }

  nav > .collapse > ul.navbar-nav:not(:last-child),
  nav > .collapsing > ul.navbar-nav:not(:last-child) {
    flex-grow: 1;
  }

  .nowrap {
    white-space: nowrap;
  }

  .banner-heading {
    background-color: ${$.secondaryMain};
    color: ${$.white};
    box-sizing: content-box;
  }

  .no-margin {
    margin: 0 !important;
  }

  .btn-submit {
    background-color: ${$.primaryMain};
    color: ${$.white};

    &:hover {
      background-color: ${darken(0.075, $.primaryMain)};
      background-image: none;
      border-color: ${darken(0.075, $.primaryMain)};
      box-shadow: 0 2px 4px 0 ${rgba($.black, 0.12)}, 0 1px 2px 0 ${rgba($.black, 0.06)};
      transform: translateY(-1px);
    }

    &:focus {
      background-color: ${darken(0.1, $.primaryMain)};
    }
  }

  .btn-save {
    background-color: ${$.successMain};
    color: ${$.white};

    &:hover {
      background-color: ${darken(0.075, $.successMain)};
    }

    &:focus {
      background-color: ${darken(0.1, $.successMain)};
    }
  }
`;
